var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.skuId
    ? _c(
        "div",
        { staticClass: "product-delivery" },
        [
          _c("product-delivery-item", {
            attrs: {
              title: "Забрать из магазина",
              description: _vm.availabilityText,
              icon: _vm.$options.icons.IconPoint.id,
              disabled: !_vm.isAvailability
            },
            nativeOn: {
              click: function($event) {
                return _vm.onClick(_vm.deliveryTypes.availability)
              }
            }
          }),
          _c("product-delivery-item", {
            attrs: {
              title: "Доставить курьером",
              description: _vm.deliveryText,
              icon: _vm.$options.icons.IconBox.id,
              disabled: !_vm.isDelivery
            },
            nativeOn: {
              click: function($event) {
                return _vm.onClick(_vm.deliveryTypes.delivery)
              }
            }
          }),
          _c("product-delivery-item", {
            attrs: {
              title: "Забрать из пункта выдачи",
              description: _vm.postamatText,
              icon: _vm.$options.icons.IconPostamat.id,
              disabled: !_vm.isPostamat
            },
            nativeOn: {
              click: function($event) {
                return _vm.onClick(_vm.deliveryTypes.postamat)
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }